/**
 * @generated SignedSource<<9c26559f911b899c733a9bc1d5a62a4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AccountGroupPicker_accountGroups$data = {
  readonly accountGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly roleAssignmentTarget: any;
        readonly userPermissions: ReadonlyArray<Permission>;
        readonly uuid: any;
      };
    }>;
  };
  readonly " $fragmentType": "AccountGroupPicker_accountGroups";
};
export type AccountGroupPicker_accountGroups$key = {
  readonly " $data"?: AccountGroupPicker_accountGroups$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountGroupPicker_accountGroups">;
};

import AccountGroupPickerRefetchQuery_graphql from './AccountGroupPickerRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "accountGroupFilterElement"
    },
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": AccountGroupPickerRefetchQuery_graphql
    }
  },
  "name": "AccountGroupPicker_accountGroups",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "accountGroupFilterElement"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "AccountGroupConnection",
      "kind": "LinkedField",
      "name": "accountGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleAssignmentTarget",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userPermissions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c0bd904d50800329426555497d3738b6";

export default node;
